import perfilResolver from "js/graphql/resolvers/perfil.resolver";
import segmentoResolver from "js/graphql/resolvers/segmento.resolver";

export const GRAPHQL_MAP = {
  models: {
    USER: {
      modelName: "UsuarioInput",
      label: "Usuario"
    },
    PERFIL: {
      modelName: "PerfilCreate",
      label: "Perfil"
    }
  },
  operations: {
    GET_DEFINITION_PROFILE_BY_ID: {
      key: "getDefinicionesPerfil",
      query: perfilResolver.queries.getDefinicionesPerfilById
    }
  },
  rules: {
    IDSEGMENTO: {
      field: "idSegmento",
      key: "getSegmentos",
      query: segmentoResolver.queries.getSegmentoById
    }
  }
};

export const TYPES_STATE = {
  listaIn: { type: "in" },
  listaNotIn: { type: "notIn" },
  IgualA: { type: "equal" },
  RegExp: { type: "regexp" },
  Default: { type: "default" }
};
